import { useConfig } from 'core/common/hooks';
import { Typography } from 'core/common/ui/ui-kit';
import { Locales } from 'core/user/entities';
import { Location, LocationOption } from 'core/user/ui';
import { FooterStyled } from './styled';

export const Footer = () => {
  const config = useConfig();
  return (
    <FooterStyled>
      <Location>
        <LocationOption option={Locales.US}>
          <Typography align="center" variant="bodySmallRegular">
            {config.addressUS}
          </Typography>
        </LocationOption>
        <LocationOption option={Locales.OTHER}>
          <Typography align="center" variant="bodyExtraSmallRegular">
            {config.address}
          </Typography>
        </LocationOption>
      </Location>
    </FooterStyled>
  );
};
